/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

export default class DataCampaignsWorkflowFeedbackForm extends Component<HelpModalComponentArgs> {
  @service analytics!: AnalyticsService;

  @tracked suggestion = '';

  get submitDisabled() {
    if (isEmpty(this.suggestion)) {
      return true;
    }

    return false;
  }

  get disabledTooltipContent() {
    if (isEmpty(this.suggestion)) {
      return 'Please enter a suggestion';
    }

    return '';
  }

  @action
  onInsert() {
    this.analytics.track('user', 'feedback_request_started', {
      source: 'Data Workflow - Workflow Tab',
    });
  }

  @action
  onSubmit(e: Event) {
    e.preventDefault();

    this.args.onSubmit({
      criticism: 'What else do you want to do with data in workflows?',
      praise: this.suggestion,
    });
  }
}
